import Index from 'Pages/community/index'

export default Index
